import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const SuccessRace = ({ session }) => {
  const [status, setStatus] = useState('Verifying your payment... Do not close this page.');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!session) return;
    const verifyPayment = async () => {
      const query = new URLSearchParams(window.location.search);
      const sessionId = query.get('session_id');
      
      if (!sessionId) {
        setStatus("Invalid checkout session."); return;
      }

      try {
        // Step 1: Securely ask backend if the Stripe session is actually PAID
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4242';
        const response = await fetch(`${apiUrl}/verify-race-fee`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId }),
        });
        
        const data = await response.json();

        if (data.verified && data.db_updated && data.userId === session.user.id) {
            setStatus("Congratulations! You are officially registered for the Regatta! Your entry was securely verified.");
            setSuccess(true);
        } else {
          setStatus("Payment verification failed or does not belong to you.");
        }
      } catch (err) {
        setStatus("Network error verifying payment.");
      }
    };

    verifyPayment();
  }, [session]);

  return (
    <div className="container" style={{ marginTop: '50px', textAlign: 'center' }}>
      <div className="card" style={{ padding: '40px', backgroundColor: success ? '#d4edda' : '#fff' }}>
        <h2 style={{ color: success ? '#155724' : '#333' }}>{status}</h2>
        {success && (
          <button onClick={() => window.location.href = '/'} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '18px' }}>
            Go to My Skipper Dashboard
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessRace;
